export default "__VITE_ASSET__BpfA5tlc__"